import { render, staticRenderFns } from "./ClientLogin.vue?vue&type=template&id=8fcba934&scoped=true"
import script from "./ClientLogin.vue?vue&type=script&lang=js"
export * from "./ClientLogin.vue?vue&type=script&lang=js"
import style0 from "./ClientLogin.vue?vue&type=style&index=0&id=8fcba934&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fcba934",
  null
  
)

export default component.exports